export default function convertDayIndexingToSatSunFormat(date: Date) {
  if (date.getDay() === 0) return 6;
  return date.getDay() - 1;
}
